module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-tab-wrap",
    class: _vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''
  }, [_c('div', {
    staticClass: "vux-tab-container"
  }, [_c('div', {
    ref: "nav",
    staticClass: "vux-tab",
    class: [{
      'vux-tab-no-animate': !_vm.animate
    }, {
      scrollable: _vm.scrollable
    }]
  }, [_vm._t("default"), _vm._v(" "), (_vm.animate) ? _c('div', {
    staticClass: "vux-tab-ink-bar",
    class: _vm.barClass,
    style: (_vm.barStyle)
  }, [(_vm.customBarWidth) ? _c('span', {
    staticClass: "vux-tab-bar-inner",
    style: (_vm.innerBarStyle)
  }) : _vm._e()]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e3b3d2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/tab/tab.vue
// module id = 572
// module chunks = 0